<div class="flex items-center">
  <img *ngIf="hideText" src="assets/assets-site/images/logos/icon.svg" class="logo_site_favicon" />
  <img
    *ngIf="!hideText"
    src="assets/assets-site/images/logos/logo-horizontal.svg"
    class="h-[40px]"
    alt="Logo"
  />
</div>
